import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ShareViaWizardSteps } from '../../constants';
import { useShareViaSettings } from '../ShareViaSettingsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SharingMethodStepFooter = () => {
  const {
    stepIndex,
    selectedApp,
    setStepIndex
  } = useShareViaSettings();
  return /*#__PURE__*/_jsxs(UIFlex, {
    justify: "between",
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      disabled: stepIndex === ShareViaWizardSteps.sharingMethodStep,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareVia.dialog.controls.backButton"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: () => setStepIndex(ShareViaWizardSteps.configurationStep),
      use: "primary",
      disabled: !selectedApp,
      "data-test-id": "share-report-dialog-next-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareVia.dialog.controls.nextButton"
      })
    })]
  });
};
export default SharingMethodStepFooter;